<h2 class="modal-title" style="margin-top: 3%; margin-left: 25px; font-weight: bold;">
  Editer un rapport favoris
</h2>
<hr style="
  border: 1px solid #262756;
  opacity: 0.23;
  top: 247px;
  left: 442px;
  width: 950px;
  height: 0px;
  margin-bottom: 3%;
" />

<div class="mt-2" style="padding-left: 37px">
  <ngx-spinner
    bdColor="rgba(100,112,124,0.56)"
    size="medium"
    color="#233547"
    type="ball-clip-rotate-multiple"
    [fullScreen]="true"
  >
    <p style="color: white"></p>
  </ngx-spinner>

  <!-- <div class="row w-100 mb-3">  
  </div> -->
  <div class="col-md-8">
    <div class="head">
      <!-- <ul class="list-group " style=" margin-bottom: 12px !important; margin-top: 12px !important">
      <li class="list-group-item active " style="color: #ffffff;   ">Nom</li></ul> -->
      <div class="nom">
        <p>Nom</p>
      </div>
      <div class="name">
        <mat-form-field class="select-score mb-3" appearance="fill">
          <input
            placeholder="Nom"
            matInput
            [(ngModel)]="name"
            value="{{name}}"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <hr />
  <div class="col-md-8">
    <div class="head">
      <!-- <ul class="list-group " style=" margin-bottom: 12px !important; margin-top: 12px !important">
      <li class="list-group-item active " style="color: #ffffff;">Période</li></ul> -->
      <div class="nom">
        <p>Période</p>
      </div>
      <div class="name">
        <mat-form-field
          style="margin-top: 7%; margin-left: -29%"
          appearance="fill"
          class="w-100"
        >
          <mat-label>Filtrer par date Début-Fin</mat-label>
          <mat-date-range-input
            [formGroup]="rangeForm"
            [min]="minDate"
            [max]="maxDate"
            [rangePicker]="picker2"
          >
            <input
              formControlName="start"
              autocomplete="off"
              readonly
              matStartDate
              placeholder="Date Début"
              [(ngModel)]="dateDebut"
            />
            <input
              formControlName="end"
              autocomplete="off"
              readonly
              matEndDate
              placeholder="End date"
              (dateChange)="addNewDate(rangeForm )"
              [(ngModel)]="dateFin"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
            placement="left"
            ngbTooltip="Filtrer par date Début-Fin"
          >
          </mat-datepicker-toggle>
          <mat-date-range-picker maxRange="29" #picker2></mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>
  </div>
  <hr />
  <div class="row mr-3 mb-3">
    <div class="col-md-5 col-lg-5 col-xl-5 w-100">
      <div class="example-container p-0">
        <div class="dispo">
          <p class="myclass">Disponible</p>
        </div>
        <div
          cdkDropList
          #todoList="cdkDropList"
          [cdkDropListData]="todo"
          [cdkDropListConnectedTo]="[doneList]"
          class="example-list"
          (cdkDropListDropped)="drop($event)"
        >
          <div class="example-box" *ngFor="let item of todo" cdkDrag>
            {{item.name}}
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-md-2 col-lg-2 col-xl-2 w-100"
      style="text-align: center"
      *ngIf="rap_fl_v == true || rap_d_v == true"
    >
      <div class="mt-5 mb-2">
        <img
          (click)="move()"
          width="35px"
          height="35px"
          src="data:image/svg+xml;base64,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"
        />
      </div>
      <div class="mt-2 mb-2">
        <img
          (click)="remove()"
          width="35px"
          height="35px"
          src="data:image/svg+xml;base64,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"
        />
      </div>
    </div>
    <div
      class="col-md-2 col-xl-2 col-lg-2"
      style="text-align: center"
      *ngIf=" rap_fl_c == true || rap_d_c == true "
    >
      <div class="mt-5 mb-2">
        <img
          (click)="move1()"
          èwidth="35px"
          height="35px"
          src="data:image/svg+xml;base64,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"
        />
      </div>
      <div class="mt-2 mb-2">
        <img
          (click)="remove1()"
          width="35px"
          height="35px"
          src="data:image/svg+xml;base64,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"
        />
      </div>
    </div>

    <div class="col-md-5 col-lg-5 col-xl-5 w-100">
      <div class="example-container pl-0">
        <div class="selec">
          <p class="myclass">Sélectionnés</p>
        </div>
        <div
          cdkDropList
          #doneList="cdkDropList"
          [cdkDropListData]="done"
          [cdkDropListConnectedTo]="[todoList]"
          class="example-list"
          (cdkDropListDropped)="drop($event)"
        >
          <div class="example-box" *ngFor="let item of done" cdkDrag>
            {{item.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="score">
    <div class="">
      <div class="" style="margin-left: -1px">
        <p class="myclass">Score de sécurité</p>
      </div>
      <div class="row" *ngIf="scr == true">
        <div class="col-md-2 col-xl-2">
          <h3 class="pt-3 title">Score</h3>
        </div>
        <div class="col-md-5 col-xl-5 mb-3">
          <mat-form-field appearance="fill">
            <mat-label>Opérateurs</mat-label>
            <mat-select disableRipple [(ngModel)]="op_sf1">
              <mat-option value="="> = </mat-option>
              <mat-option value="<>"> <> </mat-option>
              <mat-option value=">"> > </mat-option>
              <mat-option value=">="> >= </mat-option>
              <mat-option value="<"> < </mat-option>

              <mat-option value="<="> <= </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-5 col-xl-5">
          <mat-form-field
            [ngClass]="{'disabledIcon':op_sf1 == null}"
            appearance="fill"
          >
            <mat-label>Seuil</mat-label>
            <input
              matInput
              type="number"
              id="score_sfty_v1"
              [(ngModel)]="score_sf1"
            />
          </mat-form-field>
        </div>
        <div class="col-md-2 mb-2">
          <h3 class="pt-3 title">Et</h3>
        </div>

        <div class="col-md-5">
          <mat-form-field appearance="fill">
            <mat-label>Opérateurs</mat-label>

            <mat-select disableRipple [(ngModel)]="op_sf2">
              <mat-option value="="> = </mat-option>
              <mat-option value="<>"> <> </mat-option>
              <mat-option value=">"> > </mat-option>
              <mat-option value=">="> >= </mat-option>

              <mat-option value="<"> < </mat-option>

              <mat-option value="<="> <= </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-5 col-xl-5">
          <mat-form-field
            [ngClass]="{'disabledIcon':op_sf2 == null}"
            appearance="fill"
          >
            <mat-label>Seuil</mat-label>
            <input
              matInput
              type="number"
              id="score_sfty_v2"
              [(ngModel)]="score_sf2"
            />
          </mat-form-field>
        </div>

        <div class="row w-100">
          <div class="col-12">
            <mat-radio-group [(ngModel)]="scoresaf">
              <div
                class="row w-100"
                style="display: flex; justify-content: center"
              >
                <div class="col-md-3 col-xl-3 w-100">
                  <mat-radio-button
                    name="ScoreScore"
                    class="pt-3"
                    value=">="
                    (click)="getValuesf('>=')"
                    >Score >= Moy</mat-radio-button
                  >
                </div>

                <div class="col-md-3 col-xl-3 w-100">
                  <mat-radio-button
                    name="ScoreScore"
                    class="pt-3"
                    value="<="
                    (click)="getValuesf('<=')"
                    >Score <= Moy</mat-radio-button
                  >
                </div>

                <div class="col-md-3 col-xl-2 w-100">
                  <mat-radio-button
                    name="ScoreScore"
                    class="pt-3"
                    value="null"
                    (click)="getValuesf('null')"
                    >Aucun
                  </mat-radio-button>
                </div>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="" style="margin-left: -1px; margin-top: 33px">
        <p class="myclass">Score d'économie</p>
      </div>
      <div class="row" *ngIf="scr2 == true">
        <div class="col-md-2 col-xl-2">
          <h3 class="pt-3 title">Score</h3>
        </div>
        <div class="col-md-5 col-xl-5 mb-3">
          <mat-form-field appearance="fill">
            <mat-label>Opérateurs</mat-label>
            <mat-select disableRipple [(ngModel)]="op_ec1">
              <mat-option value="="> = </mat-option>
              <mat-option value="<>"> <> </mat-option>
              <mat-option value=">"> > </mat-option>
              <mat-option value=">="> >= </mat-option>

              <mat-option value="<"> < </mat-option>

              <mat-option value="<="> <= </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-5 col-xl-5">
          <mat-form-field
            [ngClass]="{'disabledIcon':op_ec1 == null}"
            appearance="fill"
          >
            <mat-label>Seuil</mat-label>
            <input
              matInput
              type="number"
              id="score_eco_v1"
              [(ngModel)]="score_ec1"
            />
          </mat-form-field>
        </div>
        <div class="col-md-2 mb-2">
          <h3 class="pt-3 title">Et</h3>
        </div>

        <div class="col-md-5">
          <mat-form-field appearance="fill">
            <mat-label>Opérateurs</mat-label>
            <mat-select disableRipple [(ngModel)]="op_ec2">
              <mat-option value="="> = </mat-option>
              <mat-option value="<>"> <> </mat-option>
              <mat-option value=">"> > </mat-option>
              <mat-option value=">="> >= </mat-option>

              <mat-option value="<"> < </mat-option>

              <mat-option value="<="> <= </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-5 col-xl-5">
          <mat-form-field
            [ngClass]="{'disabledIcon':op_ec2 == null}"
            appearance="fill"
          >
            <mat-label>Seuil</mat-label>
            <input matInput id="score_eco_v2" [(ngModel)]="score_ec2" />
          </mat-form-field>
        </div>

        <div class="row w-100">
          <div class="col-12">
            <mat-radio-group [(ngModel)]="scoreeco">
              <div
                class="row w-100"
                style="display: flex; justify-content: center"
              >
                <div class="col-md-3 col-xl-3 w-100">
                  <mat-radio-button
                    name="ecScore"
                    class="pt-3"
                    value=">="
                    (click)="getValueec('>=')"
                    >Score >= Moy
                  </mat-radio-button>
                </div>

                <div class="col-md-3 col-xl-3 w-100">
                  <mat-radio-button
                    name="ecScore"
                    class="pt-3"
                    value="<="
                    (click)="getValueec('<=')"
                    >Score <= Moy</mat-radio-button
                  >
                </div>

                <div class="col-md-3 col-xl-2 w-100">
                  <mat-radio-button
                    name="ecScore"
                    class="pt-3"
                    value="null"
                    (click)="getValueec('null')"
                    >Aucun</mat-radio-button
                  >
                </div>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="justify-content-center d-flex mt-5 my-2">
  <a class="valid text-uppercase mr-2" type="submit" (click)="addfav()"
    >Valider</a
  >
  <a class="generer text-uppercase mr-2" type="submit" (click)="generatePdf()"
    >Génerer</a
  >
  <a
    class="reenitialiser text-uppercase mr-2"
    type="reset"
    (click)="resetFormScore()"
    >Reénitialiser</a
  >
  <a class="annuler text-uppercase mr-2" type="submit" (click)="close()"
    >Annuler</a
  >
</div>
